import {
  MelcoModelsSubscriptionUserList,
  useAPIQuery,
  UserAccountApi,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useLicensesUsers = (
  includeParent?: boolean,
  product_code?: string | null
) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<MelcoModelsSubscriptionUserList>();

  const query = useAPIQuery(
    UserAccountApi,
    ["licensesUsers", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      const response = await api.accountGetSubscriptionUserList({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
        includeParent,
        productCode:
          product_code !== null && !isEmpty(product_code)
            ? product_code
            : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
